import LogoImage from '@shared/assets/zentera-wordmark.svg'
import classes from './zentera-logo.module.css'

export const ZenteraLogo = () => (
  <img className={classes.logo} src={LogoImage} alt='Zentera Wool Company logo' />
)
